import { Button } from '@pepper/ui'
import { FC } from 'react'
import { Icon } from '@iconify/react'

import NoProjects from 'assets/images/no_projects.png'

import s from './EmptyState.module.css'

type Props = {
  onCreate: () => void
}

export const EmptyState: FC<Props> = ({ onCreate }) => {
  return (
    <div className={s.newProjectLink}>
      <img src={NoProjects} alt="No assignment" className={s.img} />
      <p className={s.noProjectHeader}>Your content projects appear here..</p>
      <p className={s.noProjectSubHeader}>
        Create a project to get started. This could be the start of something
        beautiful. ✨
      </p>
      <Button
        type="ghost"
        size="small"
        onClick={onCreate}
        icon={<Icon icon="lucide:plus" />}
      >
        Create a new project
      </Button>
    </div>
  )
}
